/**
 * EliorGroup.Joyfood.B2B2C API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CompleteBankTransactionCommand { 
    shopID?: string | null;
    transactionAt?: string;
    integration_type?: string | null;
    integration_name?: string | null;
    mid?: string | null;
    paymentId?: string | null;
    instrument?: string | null;
    operation_type?: string | null;
    amount?: string | null;
    currency?: string | null;
    language?: string | null;
    transaction_type?: string | null;
    callback_url?: string | null;
    card_brand_desc?: string | null;
    service_type_desc?: string | null;
    product_priority_code?: string | null;
    payInstrToken_external?: string | null;
    payCardToken_external?: string | null;
    maskedPan?: string | null;
    card_expiration?: string | null;
    card_brand?: string | null;
    cardHolder?: string | null;
    tid?: string | null;
    transaction_status?: string | null;
    brand?: string | null;
    transactionID?: string | null;
    authStatus?: string | null;
    enrStatus?: string | null;
    authCode?: string | null;
    transaction_code?: string | null;
    description_status?: string | null;
    responseHash?: string | null;
}

